var React = require('react');

function Sitepoint (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m2.471 10.533 1.771 1.688 5.598 5.141 2.4-2.291c.21-.297.194-.705-.046-.985l-2.204-1.902.01-.005-2.371-2.266c-.279-.314-.27-.78.021-1.079l6.39-6.076-2.894-2.758-8.671 8.238c-.664.633-.664 1.66 0 2.295zm19.056 2.937-1.77-1.691-5.595-5.142-2.411 2.291c-.221.3-.207.705.045.985l2.205 1.891h-.006l2.369 2.265c.27.314.27.766-.029 1.064l-6.391 6.075 2.911 2.792 8.67-8.238c.664-.633.666-1.659 0-2.295z"}));
}

Sitepoint.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Sitepoint;

Sitepoint.default = Sitepoint;
